




































































import { Component, Vue } from 'vue-property-decorator';
import Searchbox from './Searchbox.vue';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Loader from './Loader.vue';
import Broadcast from './Broadcast.vue';
import JobAlertUI from './JobAlertUI.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import MyJoblisting from './MyJobs/JobListing/MyJoblisting.vue';
import { UserJobListRequest } from '@/models/jobs/userjoblistrequest';
import Joblisting from './Joblisting.vue';

@Component({
  name: 'FindJobs',
  components: {
    Searchbox,
    Jobseeker,
    Myreferrals,
    Broadcast,
    Joblisting,
    Loader,
    JobAlertUI,
    myjoblisting: MyJoblisting,
  },
})
export default class FindJobs extends Vue {
  jobStatus: string = '04';

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get resultCount(): any {
    return vxm.jobs.ResultCount;
  }

  get isFirstPage(): boolean {
    if (this.resultCount.resultPage === 1) {
      return true;
    } else {
      return false;
    }
  }

  totalPageCount() {
    return Math.ceil(this.resultCount.resultCount / 10);
  }

  get isLastPage(): boolean {
    if (this.resultCount.resultPage === this.totalPageCount()) {
      return true;
    } else {
      return false;
    }
  }

  getNext() {
    const ujlr = vxm.jobs.UserJobListRequest;
    ujlr.jobStatus = '04';
    ujlr.sessionToken = '123';
    ujlr.resultSize = 10;
    ujlr.resultPage = this.resultCount.resultPage + 1;
    if (this.resultCount.resultPage < this.totalPageCount()) {
      vxm.jobs.getMyJobStatus(ujlr);
    }
  }

  getPrevious() {
    const ujlr = vxm.jobs.UserJobListRequest;
    ujlr.jobStatus = '04';
    ujlr.sessionToken = '123';
    ujlr.resultSize = 10;
    ujlr.resultPage = this.resultCount.resultPage - 1;
    if (this.resultCount.resultPage > 1) {
      vxm.jobs.getMyJobStatus(ujlr);
    }
  }

  getFirst() {
    const ujlr = vxm.jobs.UserJobListRequest;
    ujlr.jobStatus = '04';
    ujlr.sessionToken = '123';
    ujlr.resultSize = 10;
    ujlr.resultPage = 1;
    if (this.resultCount.resultPage > 1) {
      vxm.jobs.getMyJobStatus(ujlr);
    }
  }

  getLast() {
    const ujlr = vxm.jobs.UserJobListRequest;
    ujlr.jobStatus = '04';
    ujlr.sessionToken = '123';
    ujlr.resultSize = 10;
    ujlr.resultPage = this.totalPageCount();
    if (this.resultCount.resultPage < this.totalPageCount()) {
      vxm.jobs.getMyJobStatus(ujlr);
    }
  }
}
